import moment from "moment"
import { banner2 } from "../../../mockup/inside";
export default {
  GET_TABLE(state, payload) {
    state.table = payload;
  },
  GET_TAB(state,payload){
    state.tab = payload
  },
  GET_RENDER_DETAIL(state,payload){
    state.renderDetail = payload
  },
  GET_DETAIL_DATA(state,payload){
    state.detailData = payload
  },
  GET_TAB_ACTIVE(state,payload){
    state.tabActive= payload
  },
  GET_ID_USER(state,payload){
    state.id_user = payload
  },
  GET_PAGE(state,payload){
    // console.log("payload",payload);
    state.page = payload
  },
  GET_COLUMN(state,payload){
    state.column = payload
  },
  GET_DATA(state,payload){
    state.data = payload
  },
  GET_DATA(state,payload){
    state.data = payload
  },
  GET_SIDBAR(state,payload){
  if(state.page.type !== "setting"){
    state.sidebar = true
  }
  },
  GET_LANGUAGE(state,payload){
    state.language = payload
  },
  CHANGE_LANGUAGE(state,payload){
    state.banner = payload
  },
  SWITCH_LANGUAGE(state,payload){
    state.language.forEach((value,index)=>{
      if (payload==index){
        value.value = true
      }
      else{
        value.value = false
      }
    })
   
  },
  CHANGE_BANNER_DATE(state,payload){
    state.start_end ={
      startDate:new Date(payload.startDate),
      endDate:new Date(payload.endDate),
    

    }

  },
  CHANGE_PUBLISH(state,payload){
    state.isPublish = payload

  },

  GET_CONTENT(state,payload){
    console.log("mutation",payload)
    state.content = payload
  },

  CHANGE_CONTENT(state,payload){
   state.content.language.forEach((el,i)=>{
     console.log(el.value)
    //  let name = el.value
     if (payload==i){
       el.value = true
     }
     else {
       el.value = false
     }
   })

  },

  PAGE_BANNER(state,payload){
    state.banner = payload
  },

  GET_BANNERTYPE(state,payload){
    state.type = banner2.type
  },
  PUSH_CONTENT(state,payload){
    console.log("sub content in mutation",payload)
    state.content = payload
  },

  PUSH_ISSHOW(state,payload){
    //console.log("isshow",payload.sub_content)
    
    // if (payload.sub_content && payload.sub_content){

    // }
    
  }


  
};
